/**
 * Bottom sheet (compound API).
 * Meant to replace the bottomSheet component.
 * Inspired by Base UI Drawer and Vaul
 *
 * https://base-ui.com/react/components/drawer
 * https://github.com/emilkowalski/vaul
 */
import "./bottomSheetDialog.scss";

import { Root } from "./Root";
import { Trigger } from "./Trigger";
import { Portal } from "./Portal";
import { Backdrop } from "./Backdrop";
import { Popup } from "./Popup";
import { Header } from "./Header";
import { Body } from "./Body";
import { Footer } from "./Footer";
import { Handle } from "./Handle";
import { Title } from "./Title";
import { Description } from "./Description";
import { Close } from "./Close";

export type { OpenChangeReason } from "./bottomSheetContext";
export type { RootProps } from "./Root";
export type { SnapPoint } from "./snapPoints";

export const BottomSheet = {
  Root,
  Trigger,
  Portal,
  Backdrop,
  Popup,
  Header,
  Body,
  Footer,
  Handle,
  Title,
  Description,
  Close,
};

export default BottomSheet;
